import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { getAvailableTournaments, getAvailableTournamentsByFilter } from './actions';
import type { AvailableTournamentsSliceState } from './available-tournaments-store';

type ReducerBuilder = ActionReducerMapBuilder<AvailableTournamentsSliceState>;

export function createGetAvailableTournamentsReducer(builder: ReducerBuilder) {
  builder.addCase(getAvailableTournaments.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getAvailableTournaments.fulfilled, (state, action) => {
    state.isLoading = false;
    state.isLoaded = true;

    const newItems = action.payload.tournaments;
    // Возвращаем конкретную страницу-окно, не накапливаем элементы
    state.tournaments = [...state.tournaments, ...newItems];
    state.userId = action.payload.userId;

    state.allDataLoaded = newItems.length < state.limit;
  });

  builder.addCase(getAvailableTournaments.rejected, (state, action) => {
    state.isLoading = false;
    state.isLoaded = false;
    state.error = action.error.message ?? null;
  });
}

export function createGetAvailableTournamentsByFilterReducer(builder: ReducerBuilder) {
  builder.addCase(getAvailableTournamentsByFilter.fulfilled, (state, action) => {
    state.filter.items = action.payload;
    state.filter.allDataLoaded = action.payload.length < state.limit;
  });
}
